import { Component, EventEmitter, Output } from '@angular/core';
import { goToAct, playChanged, progress, sceneIndex, taskIndex, user, } from 'src/app/training/training.selectors';
import { AddScene, DelStep, DelTeacherVideo, PlayScene } from '../../training.actions';
import { CareComponent } from '../care.component';

@Component({
  selector: 'overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss']
})
export class OverviewComponent extends CareComponent {
  scenes: any[] = []
  subscriptions: any[] = []
  colapsed: any = {
    intro: false,
    describe: true,
    problems: true
  }
  pat_progress: any = {}
  progress: any = {}
  @Output() hide: EventEmitter<void> = new EventEmitter();
  // bShowAdd: boolean = false

  async setInScene(_bUserSelectedCamera: boolean, _from: string) {
    let rv = this.getCurrentTaskAndScene()
    let task: any = rv.task
    if (task) {
      setTimeout(() => {
        this.scenes = task.scenes
        this.setProgress()
      })
    }
  }
  ngAfterViewInit() {
    console.log("Overview")
    this.subscriptions.push(this.pagesState.select(user).subscribe((user: any) => {
      if (user && user.customer_id) {
        this.roll = user.roll
        if (this.roll != 'care') {
          this.bShowRecUI = true
        }
      }
    }))
    // super.ngAfterViewInit()
    this.subscriptions.push(this.trainingStore.select(progress).subscribe((progress: any) => {
      if (progress) {
        this.pat_progress = progress
        console.log("overview progress " + JSON.stringify(progress))
        this.setProgress()
      }
    }))
    this.subscriptions.push(this.trainingStore.select(playChanged).subscribe((play: any) => {
      console.log("playChanged " + new Date())
      if (play && play._id) {
        this.patient_id = play._id
        this.my_play = play
        this.setInScene(false, "playChanged")
      }
    }))
    this.subscriptions.push(this.trainingStore.select(taskIndex).subscribe((index: number) => {
      if (this.task_index != index) {
        this.task_index = index
        this.setInScene(false, "taskIndex")
      }
    }))
    this.subscriptions.push(this.trainingStore.select(sceneIndex).subscribe((index: number) => {
      if (this.scene_index != index) {
        this.scene_index = index
        this.setInScene(false, "sceneIndex")
      }
    }))

    this.subscriptions.push(this.trainingStore.select(goToAct).subscribe((act: any) => {
      console.log("act " + act)
      this.act = act
      let keys = Object.keys(this.colapsed)
      for (let i = 0; i < keys.length; i++) {
        let key = keys[i]
        this.colapsed[key] = key != this.act
      }
      this.setInScene(false, "goToAct")
    }))

  }
  setProgress() {
    if (this.my_play && this.my_play._id && this.pat_progress && this.pat_progress.patients) {
      let pat = this.pat_progress.patients[this.my_play._id]
      if (pat) {
        let task = pat.tasks[this.task_key]
        if (task) {
          this.progress = task.scenes
        }
      }
    }
  }
  ngOnDestroy(): void {

    this.subscriptions.forEach((s) => {
      s.unsubscribe();
    })
  }

  playScene(act: string, index: number) {
    this.hide.emit()
    this.training_service.playScene(act, index)//Tell the other side
    this.trainingStore.dispatch(new PlayScene(act, index))
  }
  toogle(what: string) {
    if (this.isPhone) {
      let keys = Object.keys(this.colapsed)
      for (let i = 0; i < keys.length; i++) {
        let key = keys[i]
        this.colapsed[key] = key != what

      }
    } else {
      this.colapsed[what] = !this.colapsed[what]
    }
  }
  delIntroStep(step_index: number) {
    let rv = this.getCurrentTaskAndScene()
    if (rv.task && rv.task.scenes) {
      let scene = rv.task.scenes[this.scene_index]
      if (scene) {
        this.training_service.delStepVideoFromS3(rv.task, scene, 'describe')
        this.training_service.delStepVideoFromS3(rv.task, scene, 'problems')
        this.trainingStore.dispatch(new DelStep(step_index))
        // setTimeout(() => this.trainingStore.dispatch(new ReStart()))
      }
    }
  }
  delTeacherActVideo(step_index: number, act: string) {
    let rv = this.getCurrentTaskAndScene()
    if (rv.task && rv.task.scenes) {
      let scene = rv.task.scenes[this.scene_index]
      if (scene) {
        this.training_service.delStepVideoFromS3(rv.task, scene, act)
        this.trainingStore.dispatch(new DelTeacherVideo(step_index, act))
      }
    }
  }

  addScene() {
    let rv = this.getCurrentTaskAndScene()
    let task: any = rv.task

    if (task.play_movies) {
      let keys = Object.keys(task.play_movies)
      if (keys.length > 0) {
        let name: string = "Steep 1"
        let scene_s = 0
        let key = keys[0]
        let scene_e = task.play_movies[key].duration
        if (task && task.scenes && task.scenes.length > 0) {

          name = "Steep " + (task.scenes.length + 1)
          let last_scene = task.scenes[task.scenes.length - 1]

          if (last_scene) {
            scene_s = last_scene.end
            let movie = task.play_movies[last_scene.movie_name]
            if (movie && movie.duration)
              scene_e = movie.duration
          }
        }
        this.trainingStore.dispatch(new AddScene(name, scene_s, scene_e))
      }
    }
  }
}
